import { render, staticRenderFns } from "./VipMemberContent.vue?vue&type=template&id=46f074a2&scoped=true&"
import script from "./VipMemberContent.vue?vue&type=script&lang=js&"
export * from "./VipMemberContent.vue?vue&type=script&lang=js&"
import style0 from "./VipMemberContent.vue?vue&type=style&index=0&id=46f074a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f074a2",
  null
  
)

export default component.exports